import * as React from "react";
import MailingListDetails from "src/components/MailingListDetails";
import MailingListQuery from "src/queries/MailingListQuery";
import UpsertMailingList from "src/mutations/UpsertMailingList";
import { Redirect } from "react-router";

export interface Props {
  match: {
    params: {
      id: string | null;
    };
  };
}

export default (props: Props) => {
  const id = props.match.params.id;
  console.log(id);
  if (id) {
    return (
      <MailingListQuery id={id}>
        {({ loading, error, data }) => {
          if (!data) {
            return null;
          }
          if (error) {
            return <h1>ERROR</h1>;
          }
          return (
            <UpsertMailingList id={id}>
              {update => (
                <MailingListDetails
                  mailinglist={data.mailingList}
                  loading={loading}
                  onSubmit={update}
                />
              )}
            </UpsertMailingList>
          );
        }}
      </MailingListQuery>
    );
  } else {
    return (
      <UpsertMailingList id={id} add={true}>
        {(update, result) => {
          if (result.data && result.data.upsertMailingList.id) {
            return (
              <Redirect
                to={"/mailinglists/" + result.data.upsertMailingList.id}
              />
            );
          }
          return (
            <MailingListDetails
              onSubmit={update}
              add={true}
              mailinglist={null}
            />
          );
        }}
      </UpsertMailingList>
    );
  }
};



// WEBPACK FOOTER //
// ./src/screens/MailingList/MailingListPage.tsx